// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SbjefJjA2w7zux4hLKPe{margin:0}.hMxzC89cjewaXO1egtX3{flex-direction:column;gap:24px;margin-top:32px;display:flex}.oS7OKEgFQsYaj_lyDwAf{flex-direction:column;gap:12px;display:flex}.oS7OKEgFQsYaj_lyDwAf .Z53BCL1EJEoCciTzwQ4D{text-align:center}.b4lckjODphQHxS5ob3xE{margin-top:16px}.b4lckjODphQHxS5ob3xE .s96uktZfy4YOPa7fxx9U{justify-content:center;align-items:center;min-height:200px;display:flex}.b4lckjODphQHxS5ob3xE .aGDDsa3swkhK5_OPvKr3{min-height:40px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textFieldIcon": `SbjefJjA2w7zux4hLKPe`,
	"contentWrap": `hMxzC89cjewaXO1egtX3`,
	"actionsWrap": `oS7OKEgFQsYaj_lyDwAf`,
	"text": `Z53BCL1EJEoCciTzwQ4D`,
	"numbersWrap": `b4lckjODphQHxS5ob3xE`,
	"loader": `s96uktZfy4YOPa7fxx9U`,
	"noResults": `aGDDsa3swkhK5_OPvKr3`
};
export default ___CSS_LOADER_EXPORT___;
